import request from "@/lib/util/request";
import {
    CancelCollectParamsType,
    CollectBodyType, CollectResponseType, GetMyCollectResponseDatum,
    GetProductDetail,
    GetProductParams,
    PageInterface
} from "@/lib/type/product.type";
import {HomeDataInterface, ProductDetailType} from "@/lib/type/home-data.type";
import {AccessToken} from "@/lib/type/login-register.type";

// 获取商品列表
export const requestGetProductList = (params: GetProductParams) => request<PageInterface<HomeDataInterface[]>>({
    endpoint: "/api/tiny-shop/v1/product/product/list",
    method: "GET",
    params,
    cache: "no-store"
});

// 获取商品详情
export const requestGetProductDetail = (params: GetProductDetail) => request<ProductDetailType>({
    endpoint: "/api/tiny-shop/v1/product/product/view",
    method: "GET",
    params,
    cache: "no-store"
});


// 收藏产品
export const requestCollectProduct = (data: CollectBodyType,params:AccessToken) => request<CollectResponseType>({
    endpoint: "/api/tiny-shop/v1/member/collect/create",
    method: "POST",
    params,
    body:data,
    cache: "no-store"
});

// 取消收藏
export const requestCancelCollectProduct = (data: CancelCollectParamsType) => request<CollectResponseType>({
    endpoint: "/api/tiny-shop/v1/member/collect/delete",
    method: "DELETE",
    params:data,
    cache: "no-store"
});

//查询我的收藏
export const requestMyCollect = (params:AccessToken) => request<GetMyCollectResponseDatum[]>({
    endpoint: "/api/tiny-shop/v1/member/collect/index",
    method: "GET",
    params,
    cache: "no-store"
});

//获取可选的规格值组合
export const requestGetAvailableSpecValues = (params:{product_id:string,selected_spec_values:string,selected_spec_ids:string}) => request<any>({
  endpoint: "/api/tiny-shop/v1/product/product/get-available-spec-values",
  method: "GET",
  params,
  cache: "no-store"
});